import React, { useState, useMemo, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Phone,
  MessageCircle,
  User,
  Settings,
  LogOut,
  Bell,
  Globe,
  QrCode,
  Calendar,
  FileText,
  Heart,
  Video,
  Mic,
  MicOff,
  VideoOff,
  Users,
  Clock,
  Star,
  Download,
  Share,
  Plus,
  Search,
  Filter,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  Check,
  AlertTriangle,
  Info,
  ArrowRight,
  Volume2,
  VolumeX,
  Play,
  Pause,
  Loader2,
} from "lucide-react";
import quantumLogo from "../../quantum-care-logo.png";
import patientimg from "../../patient.png";
import {
  GetAppointmentDetailsApi,
  GetPatientAppointmentsApi,
} from "./PatientAPI";
import { FormattedMessage, useIntl } from "react-intl";
import { Context } from "../../CommonComponents/Wrapper";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { useSpeech } from "react-text-to-speech";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../CommonComponents/Select";
// Doctors data for appointment booking
const doctors = [
  {
    name: "Dr. Emily Chen",
    specialty: "General Practice",
    rating: 5.0,
    reviews: 127,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
  {
    name: "Dr. Michael Rodriguez",
    specialty: "Internal Medicine",
    rating: 5.0,
    reviews: 89,
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
  {
    name: "Dr. Sarah Thompson",
    specialty: "Family Medicine",
    rating: 5.0,
    reviews: 156,
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
];

function DashboardWhite() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { locale, selectLang } = useContext(Context);
  const [language, setLanguage] = useState("en-US");
  const [chatMessages, setChatMessages] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [symptoms, setSymptoms] = useState("");
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [filter, setFilter] = useState("all");
  const mockAppointments = useSelector(
    (state) => state.patient.patientAppointments
  );
  const AppointmentDetails = useSelector(
    (state) => state.patient.AppointmentDetails
  );

  // Video call states
  const [isInWaitingRoom, setIsInWaitingRoom] = useState(false);
  const [isOnVideoCall, setIsOnVideoCall] = useState(false);
  const [callEnded, setCallEnded] = useState(false);

  //Voice Modal
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [isCallActive, setIsCallActive] = useState(false);
  const [agentWindow, setAgentWindow] = useState(null);
  const generateRandomDoctor = (appointmentId) => {
    const maldivianDoctors = [
      "Dr. Ahmed Nasheed",
      "Dr. Mariyam Hassan",
      "Dr. Ibrahim Waheed",
      "Dr. Aisha Mohamed",
      "Dr. Hassan Ali",
      "Dr. Fathimath Naseer",
      "Dr. Mohamed Rasheed",
      "Dr. Aminath Ibrahim",
      "Dr. Ali Rameez",
      "Dr. Hawwa Shiuna",
      "Dr. Ismail Ahmed",
      "Dr. Khadija Hussain",
      "Dr. Hussain Manik",
      "Dr. Zeeniya Abdul",
      "Dr. Rasheed Mohamed",
      "Dr. Shaheena Ali",
      "Dr. Abdul Gafoor",
      "Dr. Mariyam Didi",
      "Dr. Ahmed Saleem",
      "Dr. Naseer Ibrahim",
    ];

    // Handle undefined or null appointmentId
    if (!appointmentId) {
      console.warn("No appointment ID provided, using fallback doctor");
      return maldivianDoctors[0];
    }

    // Convert to string and extract numeric part for consistent selection
    const numericId = String(appointmentId).replace(/\D/g, "") || "0";
    const index = parseInt(numericId) % maldivianDoctors.length;

    return maldivianDoctors[index];
  };

  // Your actual ElevenLabs agent URL
  const ELEVENLABS_AGENT_URL =
    "https://elevenlabs.io/app/talk-to?agent_id=agent_9801k3nygv22ea9sjqjh9gan05q8";

  // Voice agent functions
  const startVoiceAgent = () => {
    try {
      // Open ElevenLabs agent in popup window immediately
      const newWindow = window.open(
        ELEVENLABS_AGENT_URL,
        "elevenlabs-voice-agent",
        "width=800,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=yes,status=yes"
      );

      if (newWindow) {
        setAgentWindow(newWindow);
        setIsCallActive(true);
        setShowVoiceModal(true); // Show modal for status/feedback

        // Monitor when the popup window is closed
        const checkClosed = setInterval(() => {
          if (newWindow.closed) {
            setIsCallActive(false);
            setAgentWindow(null);
            setShowVoiceModal(false); // Close modal when popup closes
            clearInterval(checkClosed);
          }
        }, 1000);

        // Focus on the new window
        newWindow.focus();
      } else {
        alert(
          "Popup blocked! Please allow popups for this site and try again."
        );
      }
    } catch (error) {
      console.error("Error opening voice agent:", error);
      alert("Failed to open voice agent. Please check your browser settings.");
    }
  };

  const endVoiceAgent = () => {
    if (agentWindow && !agentWindow.closed) {
      agentWindow.close();
    }
    setIsCallActive(false);
    setAgentWindow(null);
    setShowVoiceModal(false);
  };

  const closeVoiceModal = () => {
    if (isCallActive) {
      endVoiceAgent();
    } else {
      setShowVoiceModal(false);
    }
  };

  useEffect(() => {
    dispatch(GetPatientAppointmentsApi(1));
  }, []);

  const callAppointmentDetails = (appointmentId) => {
    dispatch(GetAppointmentDetailsApi(appointmentId));
  };

  useEffect(() => {
    selectLang(language);
  }, [language]);

  // Mock Data
  const mockUser = {
    name: "Ahmed Hassan",
    email: "ahmed.hassan@example.mv",
    avatar: patientimg,
    role: "Patient",
    mrn: "MRN-2024-001",
    phone: "+960 123 4567",
    status: "online",
  };

  // const mockAppointments = [
  //   {
  //     id: "1",
  //     doctor: "Dr. Aisha Ibrahim",
  //     date: "2024-01-20",
  //     time: "14:00",
  //     type: "phone",
  //     status: "upcoming",
  //   },
  //   {
  //     id: "2",
  //     doctor: "Dr. Mohamed Ali",
  //     date: "2024-01-15",
  //     time: "10:30",
  //     type: "chat",
  //     status: "completed",
  //   },
  // ];

  function generateMockAppointments(count = 100) {
    const doctors = [
      "Dr. Aisha Ibrahim",
      "Dr. Mohamed Ali",
      "Dr. Emily Chen",
      "Dr. Michael Rodriguez",
      "Dr. Sarah Thompson",
    ];
    const types = ["phone", "chat"];
    const statuses = ["upcoming", "completed", "cancelled"];
    const appointments = [];
    for (let i = 0; i < count; i++) {
      const name = doctors[i % doctors.length];
      appointments.push({
        id: `${i + 1}`,
        doctor: name,
        date: `2024-01-${(10 + (i % 20)).toString().padStart(2, "0")}`,
        time: `${9 + (i % 10)}:00`,
        type: types[i % types.length],
        status: statuses[i % statuses.length],
      });
    }
    return appointments;
  }

  const allMockAppointments = generateMockAppointments(200);

  // Handle appointment slot selection
  const handleSlotSelect = (doctor, time) => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString();
    setSelectedAppointment({
      doctor: doctor.name,
      time,
      date: `Today, ${formattedDate}`,
    });
  };

  // Video call handlers
  const handleJoinVideoCall = () => {
    setIsInWaitingRoom(false);
    setIsOnVideoCall(true);
    setCallEnded(false);
  };

  const handleEndCall = () => {
    setIsOnVideoCall(false);
    setCallEnded(true);
  };

  const handleCallEndedClose = () => {
    setCallEnded(false);
    setCurrentPage("appointments");
  };

  const startVideoCall = () => {
    setIsInWaitingRoom(true);
  };

  // NEW: AppointmentSummaryPage Component (Web-optimized)
  const AppointmentSummaryPage = () => {
    // Mock appointment data - in real app, this would be passed from the appointments list
    const appointmentSummary = {
      id: "2",
      doctor: "Dr. Mohamed Ali",
      specialty: "Internal Medicine",
      date: "January 15, 2024",
      time: "10:30 AM",
      duration: "30 minutes",
      status: "Completed",
      type: "Video Consultation",
      symptoms: ["Seasonal allergies", "Runny nose", "Sneezing", "Watery eyes"],
      aiSummary: `Patient presented with classic symptoms of seasonal allergies including runny nose, frequent sneezing, and watery eyes. Symptoms began approximately one week ago and have been progressively worsening. No fever reported. Patient has a history of similar seasonal allergic reactions in previous years. Physical examination was normal except for mild nasal congestion and slightly reddened eyes. Recommended antihistamine treatment and environmental modifications.`,
      doctorNotes:
        "Patient responds well to antihistamine therapy. Advised to continue current treatment and return if symptoms persist beyond 2 weeks.",
      prescription: {
        medication: "Cetirizine (Zyrtec)",
        strength: "10mg",
        dosage: "One tablet daily",
        duration: "30 days",
        instructions:
          "Take with or without food. May cause drowsiness in some patients.",
        refills: "2 refills remaining",
        prescribedDate: "January 15, 2024",
      },
      integratedDeviceTests: {
        recommendedTests: ["Blood Pressure", "Glucose", "ECG"],
        nearestPHC: {
          name: "PHC A - Downtown",
          address: "123 Main Street, Malé",
          phone: "+960 330 1234",
          distance: "0.8 km",
          operatingHours: "8:00 AM - 6:00 PM",
          availableServices: [
            "Blood Pressure Monitor",
            "Glucose Meter",
            "ECG Machine",
            "Pulse Oximeter",
          ],
        },
      },
      referredTests: [
        {
          id: "1",
          testName: "Complete Blood Count (CBC)",
          category: "Blood Tests",
          urgency: "Routine",
          status: "Pending",
          scheduledDate: "January 22, 2024",
          labLocation: "QuantumCare Lab - Central Branch",
          instructions:
            "Fasting not required. Results available within 24-48 hours.",
          reason:
            "Rule out any underlying blood disorders contributing to fatigue",
        },
        {
          id: "2",
          testName: "Allergy Panel (IgE)",
          category: "Blood Tests",
          urgency: "Routine",
          status: "Scheduled",
          scheduledDate: "January 20, 2024",
          labLocation: "QuantumCare Lab - Central Branch",
          instructions:
            "Avoid antihistamines 3 days before test for accurate results.",
          reason: "Identify specific allergens causing seasonal reactions",
        },
      ],
      referredDoctor: {
        name: "Dr. Sarah Ahmed",
        specialty: "Allergy & Immunology",
        hospital: "Maldives National Hospital",
        appointmentDate: "January 25, 2024",
        appointmentTime: "2:00 PM",
        urgency: "Routine",
        status: "Scheduled",
        reason:
          "Comprehensive allergy evaluation and long-term management plan",
        contactNumber: "+960 330 5678",
        location: "Building A, 3rd Floor, Room 302",
        instructions:
          "Bring all previous allergy test results and current medications list",
      },
      nextSteps: [
        "Continue prescribed medication as directed",
        "Avoid known allergens when possible",
        "Use air purifier in bedroom",
        "Follow up if symptoms worsen or persist beyond 2 weeks",
      ],
      vitals: {
        bloodPressure: "120/80 mmHg",
        heartRate: "72 bpm",
        temperature: "98.6°F",
        oxygenSaturation: "99%",
      },
    };

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  {
                    <FormattedMessage id="AppointmentDetails.AppointmentSummary" />
                  }
                </h1>
                <p className="text-gray-600">
                  {
                    <FormattedMessage id="AppointmentDetails.Detailedsummaryofyourconsultation" />
                  }
                </p>
              </div>
              <div className="flex space-x-3">
                <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                  <Download className="h-4 w-4 mr-2" />
                  {<FormattedMessage id="AppointmentDetails.DownloadPDF" />}
                </button>
                {/* <button className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
                  <Share className="h-4 w-4 mr-2" />
                  {<FormattedMessage id="Common.Share" />}
                </button> */}
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Left Column - Appointment Details */}
            <div className="lg:col-span-1 space-y-6">
              {/* Appointment Info Card */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {
                    <FormattedMessage id="AppointmentDetails.AppointmentDetails" />
                  }
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <User className="h-5 w-5 text-gray-400 mr-3" />
                    <div>
                      <p className="font-medium text-gray-900">
                        {generateRandomDoctor(AppointmentDetails?.id)}
                      </p>
                      <p className="text-sm text-gray-600">
                        {appointmentSummary.specialty}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <Calendar className="h-5 w-5 text-gray-400 mr-3" />
                    <div>
                      {/* <p className="font-medium text-gray-900">
                        {appointmentSummary.date}
                      </p> */}
                      {/* <p className="text-sm text-gray-600">
                        {appointmentSummary.time} •{" "}
                        {appointmentSummary.duration}
                      </p> */}
                      {AppointmentDetails?.appointmentDateTime && (
                        <>
                          <p className="font-medium text-gray-900">
                            {new Intl.DateTimeFormat("en-US", {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            }).format(
                              new Date(AppointmentDetails.appointmentDateTime)
                            )}
                          </p>

                          <p className="text-sm text-gray-600">
                            {new Intl.DateTimeFormat("en-US", {
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            }).format(
                              new Date(AppointmentDetails.appointmentDateTime)
                            )}
                            {appointmentSummary?.duration &&
                              ` • ${appointmentSummary.duration}`}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <Video className="h-5 w-5 text-gray-400 mr-3" />
                    <div>
                      <p className="font-medium text-gray-900">
                        {AppointmentDetails?.consultationType} Consultation
                      </p>
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {AppointmentDetails?.status}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Vitals Card */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {<FormattedMessage id="AppointmentDetails.VitalSigns" />}
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-3 bg-gray-50 rounded-lg">
                    <p className="text-2xl font-bold text-gray-900">
                      {appointmentSummary.vitals.bloodPressure.split(" ")[0]}
                    </p>
                    <p className="text-xs text-gray-600">Blood Pressure</p>
                  </div>
                  <div className="text-center p-3 bg-gray-50 rounded-lg">
                    <p className="text-2xl font-bold text-gray-900">
                      {appointmentSummary.vitals.heartRate.split(" ")[0]}
                    </p>
                    <p className="text-xs text-gray-600">Heart Rate</p>
                  </div>
                  <div className="text-center p-3 bg-gray-50 rounded-lg">
                    <p className="text-2xl font-bold text-gray-900">
                      {appointmentSummary.vitals.temperature.split("°")[0]}°
                    </p>
                    <p className="text-xs text-gray-600">Temperature</p>
                  </div>
                  <div className="text-center p-3 bg-gray-50 rounded-lg">
                    <p className="text-2xl font-bold text-gray-900">
                      {appointmentSummary.vitals.oxygenSaturation.split("%")[0]}
                      %
                    </p>
                    <p className="text-xs text-gray-600">Oxygen Sat</p>
                  </div>
                </div>
              </div>

              {/* Symptoms */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {
                    <FormattedMessage id="AppointmentDetails.ReportedSymptoms" />
                  }
                </h3>
                <div className="flex flex-wrap gap-2">
                  {appointmentSummary.symptoms.map((symptom, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
                    >
                      {symptom}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column - Summary & Prescription */}
            <div className="lg:col-span-2 space-y-6">
              {/* AI Summary */}

              {/* Doctor's Notes */}

              {/* Digital Prescription */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {
                      <FormattedMessage id="AppointmentDetails.DigitalPrescription" />
                    }
                  </h3>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                    Active
                  </span>
                </div>

                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-4 text-white">
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="text-lg font-semibold">
                          {appointmentSummary.prescription.medication}
                        </h4>
                        <p className="text-blue-100">
                          {appointmentSummary.prescription.strength}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-blue-100">Prescribed</p>
                        <p className="font-semibold">
                          {appointmentSummary.prescription.prescribedDate}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-6 space-y-4">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <h5 className="font-semibold text-gray-900 mb-2">
                          {<FormattedMessage id="AppointmentDetails.Dosage" />}
                        </h5>
                        <p className="text-gray-700">
                          {appointmentSummary.prescription.dosage}
                        </p>
                      </div>
                      <div>
                        <h5 className="font-semibold text-gray-900 mb-2">
                          {
                            <FormattedMessage id="AppointmentDetails.Duration" />
                          }
                        </h5>
                        <p className="text-gray-700">
                          {appointmentSummary.prescription.duration}
                        </p>
                      </div>
                    </div>

                    <div>
                      <h5 className="font-semibold text-gray-900 mb-2">
                        {
                          <FormattedMessage id="AppointmentDetails.Instructions" />
                        }
                      </h5>
                      <p className="text-gray-700 bg-yellow-50 p-3 rounded border border-yellow-200">
                        {appointmentSummary.prescription.instructions}
                      </p>
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                      <span className="text-sm text-gray-600">
                        {appointmentSummary.prescription.refills}
                      </span>
                      <div className="flex space-x-2">
                        <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm">
                          {
                            <FormattedMessage id="AppointmentDetails.DownloadPrescription" />
                          }
                        </button>
                        <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
                          {
                            <FormattedMessage id="AppointmentDetails.SendtoPharmacy" />
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Integrated Device Tests */}
              {/* Integrated Device Tests Section - ADD THIS BELOW Digital Prescription */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-6">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <span className="text-blue-600 text-sm">🩺</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {
                      <FormattedMessage id="AppointmentDetails.RecommendedDeviceTests" />
                    }
                  </h3>
                </div>

                {/* Recommended Tests */}
                <div className="mb-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">
                    {
                      <FormattedMessage id="AppointmentDetails.TeststoPerform" />
                    }
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {appointmentSummary.integratedDeviceTests.recommendedTests.map(
                      (test, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
                        >
                          {test}
                        </span>
                      )
                    )}
                  </div>
                </div>

                {/* Nearest PHC Details */}
                <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h4 className="text-lg font-bold text-gray-900">
                        {
                          appointmentSummary.integratedDeviceTests.nearestPHC
                            .name
                        }
                      </h4>
                      <p className="text-gray-600 mt-1">
                        {
                          appointmentSummary.integratedDeviceTests.nearestPHC
                            .address
                        }
                      </p>
                    </div>
                    {/* <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                      {
                        appointmentSummary.integratedDeviceTests.nearestPHC
                          .distance
                      }{" "}
                      away
                    </span> */}
                  </div>

                  <div className="grid md:grid-cols-2 gap-6 mb-4">
                    <div>
                      <p className="text-sm font-medium text-gray-700">
                        Contact:
                      </p>
                      <p className="text-gray-900">
                        {
                          appointmentSummary.integratedDeviceTests.nearestPHC
                            .phone
                        }
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-700">
                        Operating Hours:
                      </p>
                      <p className="text-gray-900">
                        {
                          appointmentSummary.integratedDeviceTests.nearestPHC
                            .operatingHours
                        }
                      </p>
                    </div>
                  </div>

                  {/* <div className="mb-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Available Test Equipment:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {appointmentSummary.integratedDeviceTests.nearestPHC.availableServices.map(
                        (service, index) => (
                          <span
                            key={index}
                            className="inline-flex items-center px-2 py-1 rounded-md bg-white border border-green-200 text-sm text-green-700"
                          >
                            {service}
                          </span>
                        )
                      )}
                    </div>
                  </div> */}

                  <div className="flex justify-end space-x-2">
                    <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm">
                      Get Directions
                    </button>
                    <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
                      Call PHC
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-6">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                    <span className="text-purple-600 text-sm">🧪</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {
                      <FormattedMessage id="AppointmentDetails.ReferredLabTests" />
                    }
                  </h3>
                </div>

                <div className="space-y-4">
                  {appointmentSummary.referredTests.map((test, index) => (
                    <div
                      key={test.id}
                      className="bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-lg p-4"
                    >
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <h4 className="font-semibold text-gray-900 text-lg">
                            {test.testName}
                          </h4>
                          <div className="flex items-center space-x-4 mt-1">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                              {test.category}
                            </span>
                            <span
                              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                test.status === "Scheduled"
                                  ? "bg-green-100 text-green-800"
                                  : test.status === "Pending"
                                  ? "bg-yellow-100 text-yellow-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {test.status}
                            </span>
                            <span className="text-xs text-gray-600">
                              {test.urgency} Priority
                            </span>
                          </div>
                        </div>
                        <div className="text-right text-sm text-gray-600">
                          <p className="font-medium">Scheduled</p>
                          <p>{test.scheduledDate}</p>
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4 mb-3">
                        <div>
                          <p className="text-sm font-medium text-gray-700">
                            Location:
                          </p>
                          <p className="text-sm text-gray-600">
                            {test.labLocation}
                          </p>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-700">
                            Reason:
                          </p>
                          <p className="text-sm text-gray-600">{test.reason}</p>
                        </div>
                      </div>

                      <div className="bg-white p-3 rounded border border-purple-100">
                        <p className="text-sm font-medium text-gray-700 mb-1">
                          Special Instructions:
                        </p>
                        <p className="text-sm text-gray-600">
                          {test.instructions}
                        </p>
                      </div>

                      <div className="flex justify-end space-x-2 mt-3">
                        <button className="px-3 py-1 bg-purple-600 text-white rounded text-sm hover:bg-purple-700 transition-colors">
                          View Details
                        </button>
                        <button className="px-3 py-1 bg-gray-100 text-gray-700 rounded text-sm hover:bg-gray-200 transition-colors">
                          Reschedule
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* NEW: Referred Doctor Section */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-6">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                    <span className="text-orange-600 text-sm">👨‍⚕️</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {
                      <FormattedMessage id="AppointmentDetails.ReferredtoSpecialist" />
                    }
                  </h3>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-lg p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center">
                      <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-600 rounded-full flex items-center justify-center mr-4">
                        <User className="h-8 w-8 text-white" />
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900">
                          {appointmentSummary.referredDoctor.name}
                        </h4>
                        <p className="text-orange-700 font-medium">
                          {appointmentSummary.referredDoctor.specialty}
                        </p>
                        <p className="text-sm text-gray-600">
                          {appointmentSummary.referredDoctor.hospital}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <span
                        className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                          appointmentSummary.referredDoctor.status ===
                          "Scheduled"
                            ? "bg-green-100 text-green-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {appointmentSummary.referredDoctor.status}
                      </span>
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6 mb-4">
                    <div className="space-y-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700">
                          Appointment Date & Time:
                        </p>
                        <p className="text-gray-900 font-medium">
                          {appointmentSummary.referredDoctor.appointmentDate} at{" "}
                          {appointmentSummary.referredDoctor.appointmentTime}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-700">
                          Location:
                        </p>
                        <p className="text-sm text-gray-600">
                          {appointmentSummary.referredDoctor.location}
                        </p>
                      </div>
                    </div>
                    <div className="space-y-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700">
                          Contact:
                        </p>
                        <p className="text-sm text-gray-600">
                          {appointmentSummary.referredDoctor.contactNumber}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-700">
                          Priority:
                        </p>
                        <p className="text-sm text-gray-600">
                          {appointmentSummary.referredDoctor.urgency}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Reason for Referral:
                    </p>
                    <p className="text-gray-700 bg-white p-3 rounded border border-orange-100">
                      {appointmentSummary.referredDoctor.reason}
                    </p>
                  </div>

                  <div className="bg-white p-3 rounded border border-orange-100">
                    <p className="text-sm font-medium text-gray-700 mb-1">
                      Instructions for Appointment:
                    </p>
                    <p className="text-sm text-gray-600">
                      {appointmentSummary.referredDoctor.instructions}
                    </p>
                  </div>

                  <div className="flex justify-end space-x-2 mt-4">
                    <button className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors text-sm">
                      View Specialist Profile
                    </button>
                    <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
                      Reschedule
                    </button>
                  </div>
                </div>
              </div>
              {/* Next Steps */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {
                    <FormattedMessage id="AppointmentDetails.NextSteps&Follow-up" />
                  }
                </h3>
                <div className="space-y-3">
                  {appointmentSummary.nextSteps.map((step, index) => (
                    <div key={index} className="flex items-start">
                      <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                        <span className="text-xs font-semibold text-teal-600">
                          {index + 1}
                        </span>
                      </div>
                      <p className="text-gray-700">{step}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Actions */}
              <div className="flex flex-wrap gap-4 justify-end">
                <button
                  onClick={() => setCurrentPage("bookappointment")}
                  className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium"
                >
                  Book Follow-up
                </button>
                <button
                  onClick={() => setCurrentPage("appointments")}
                  className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
                >
                  Back to Appointments
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // WaitingRoomPage Component
  const WaitingRoomPage = ({ onJoin }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center">
        <div className="mb-6">
          <svg
            className="animate-spin h-16 w-16 text-blue-600 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          You're in the waiting room
        </h2>

        <p className="text-gray-600 mb-6">
          Dr. Emily Chen will join you shortly
        </p>

        <div className="space-y-2 mb-6">
          <p className="text-gray-700">
            <span className="font-semibold">Appointment Time:</span> 2:00 PM
          </p>
          <p className="text-gray-700">
            <span className="font-semibold">Estimated Wait:</span> 3-5 minutes
          </p>
        </div>

        <button
          onClick={onJoin}
          className="bg-green-600 text-white px-6 py-3 rounded-lg flex items-center justify-center mx-auto hover:bg-green-700 transition-colors"
        >
          <Video className="h-6 w-6 mr-2" />
          Join Video Call
        </button>
      </div>
    </div>
  );

  // VideoCallPage Component
  const VideoCallPage = ({ onEndCall }) => {
    const [micOn, setMicOn] = useState(true);
    const [videoOn, setVideoOn] = useState(true);

    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-semibold mb-6 text-gray-900">
            Video Consultation with{" "}
            {generateRandomDoctor(AppointmentDetails?.id)}
          </h2>

          {/* Main Video Container */}
          <div className="relative rounded-xl overflow-hidden bg-black h-96 mb-6 shadow-lg">
            <img
              src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
              alt="Dr. Emily Chen"
              className="object-cover w-full h-full"
            />

            {/* Video Controls Overlay */}
            <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-black bg-opacity-70 rounded-full px-6 py-3">
              <button
                onClick={() => setMicOn(!micOn)}
                className={`p-3 rounded-full transition-colors ${
                  micOn
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-red-600 hover:bg-red-700"
                }`}
                title={micOn ? "Mute Microphone" : "Unmute Microphone"}
              >
                {micOn ? (
                  <Mic className="h-6 w-6 text-white" />
                ) : (
                  <MicOff className="h-6 w-6 text-white" />
                )}
              </button>

              <button
                onClick={() => setVideoOn(!videoOn)}
                className={`p-3 rounded-full transition-colors ${
                  videoOn
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-red-600 hover:bg-red-700"
                }`}
                title={videoOn ? "Turn Off Video" : "Turn On Video"}
              >
                {videoOn ? (
                  <Video className="h-6 w-6 text-white" />
                ) : (
                  <VideoOff className="h-6 w-6 text-white" />
                )}
              </button>

              <button
                onClick={onEndCall}
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-semibold transition-colors"
                title="End Call"
              >
                End Call
              </button>
            </div>
          </div>

          {/* Local Participant Video */}
          <div className="flex items-center space-x-4">
            <div className="relative rounded-lg overflow-hidden bg-black w-40 h-28 shadow-md">
              <img
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="You"
                className="object-cover w-full h-full"
              />
              <div className="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                You
              </div>
            </div>
            <div>
              <p className="text-gray-700 font-medium">In consultation</p>
              <p className="text-gray-500 text-sm">Video quality: HD</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // CallEndedPage Component
  const CallEndedPage = ({ onClose }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full text-center p-8">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Call Ended
        </h2>
        <p className="text-gray-600 mb-8">
          Your video consultation with Dr. Emily Chen has ended. You'll receive
          a summary of your consultation shortly.
        </p>

        <div className="space-y-3">
          <button
            onClick={onClose}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Return to Dashboard
          </button>
          <button
            onClick={() => setCurrentPage("bookappointment")}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            Book Another Appointment
          </button>
        </div>
      </div>
    </div>
  );

  // Navigation Component (unchanged)
  const Navigation = () => (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <img src={quantumLogo} style={{ width: "200px" }} />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:block ml-10">
              <div className="flex items-baseline space-x-4">
                <button
                  onClick={() => setCurrentPage("home")}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === "home"
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {<FormattedMessage id="PatientDashboard.Home" />}
                </button>
                <button
                  onClick={() => setCurrentPage("appointments")}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === "appointments"
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {<FormattedMessage id="PatientDashboard.Appointments" />}
                </button>
                <button
                  onClick={() => setCurrentPage("records")}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === "records"
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {<FormattedMessage id="PatientDashboard.HealthRecords" />}
                </button>
                <button
                  onClick={() => setCurrentPage("mentalHealth")}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === "mentalHealth"
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {<FormattedMessage id="PatientDashboard.MentalHealth" />}
                </button>
              </div>
            </div>
          </div>

          {/* Right side - Language toggle, notifications, and user menu */}
          <div className="flex items-center space-x-4">
            {/* Language Toggle */}
            {/* <button
              onClick={() => setLanguage(language === "en" ? "dv" : "en")}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              title="Switch Language"
            >
              <Globe className="h-5 w-5" />
            </button> */}
            {/* <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="p-2 rounded-md border border-gray-300 text-gray-600 hover:border-gray-500 transition-colors"
            >
              <option value="en-US">English</option>
              <option value="dh-ML">ދިވެހި</option>
              <option value="si-SI">සිංහල</option>
            </select> */}
            <div className="w-32">
              <Select
                value={language}
                onValueChange={(value) => setLanguage(value)}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select language" />
                </SelectTrigger>
                <SelectContent className="w-32 bg-white">
                  <SelectItem value="en-US">English</SelectItem>
                  <SelectItem value="dh-ML">ދިވެހި</SelectItem>
                  <SelectItem value="si-SI">සිංහල</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Notifications */}
            <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors relative">
              <Bell className="h-5 w-5" />
              <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full"></span>
            </button>

            {/* User Menu */}
            <div className="relative">
              <button
                onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                className="flex items-center space-x-3 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              >
                <img
                  src={patientimg}
                  alt={mockUser.name}
                  className="h-10 w-10 rounded-md object-cover"
                />
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-900">
                    {mockUser.name}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">{mockUser.role}</p>
                </div>
                <ChevronDown className="h-4 w-4" />
              </button>

              {/* Dropdown Menu */}
              {userDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                  <button
                    onClick={() => {
                      setCurrentPage("profile");
                      setUserDropdownOpen(false);
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <User className="mr-3 h-4 w-4" />
                    Profile
                  </button>
                  <button
                    onClick={() => {
                      setCurrentPage("settings");
                      setUserDropdownOpen(false);
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <Settings className="mr-3 h-4 w-4" />
                    Settings
                  </button>
                  {/* <hr className="my-1" />
                  <button
                    onClick={() => {
                      Navigate("/doctordashboard");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Doctor Dashboard
                  </button>
                  <button
                    onClick={() => {
                      Navigate("/nursedashboard");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Nurse Dashboard
                  </button> */}
                  <hr className="my-1" />
                  <button
                    className="flex items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left"
                    onClick={() => {
                      Navigate("/");
                    }}
                  >
                    <LogOut className="mr-3 h-4 w-4" />
                    Log out
                  </button>
                </div>
              )}
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                {isMobileMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-50 border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button
              onClick={() => {
                setCurrentPage("home");
                setIsMobileMenuOpen(false);
              }}
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 w-full text-left"
            >
              Home
            </button>
            <button
              onClick={() => {
                setCurrentPage("appointments");
                setIsMobileMenuOpen(false);
              }}
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 w-full text-left"
            >
              Appointments
            </button>
            <button
              onClick={() => {
                setCurrentPage("records");
                setIsMobileMenuOpen(false);
              }}
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 w-full text-left"
            >
              Health Records
            </button>
          </div>
        </div>
      )}
    </nav>
  );

  // Call Now Interface Page Component
  const CallNowPage = () => {
    const [isCallActive, setIsCallActive] = useState(false);
    const [agentWindow, setAgentWindow] = useState(null);

    // Your actual ElevenLabs agent URL
    const ELEVENLABS_AGENT_URL =
      "https://elevenlabs.io/app/talk-to?agent_id=agent_9801k3nygv22ea9sjqjh9gan05q8";

    const startVoiceAgent = () => {
      try {
        // Open ElevenLabs agent in a new popup window
        const newWindow = window.open(
          ELEVENLABS_AGENT_URL,
          "elevenlabs-voice-agent",
          "width=800,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=yes,status=yes"
        );

        if (newWindow) {
          setAgentWindow(newWindow);
          setIsCallActive(true);

          // Monitor when the popup window is closed
          const checkClosed = setInterval(() => {
            if (newWindow.closed) {
              setIsCallActive(false);
              setAgentWindow(null);
              clearInterval(checkClosed);
            }
          }, 1000);

          // Focus on the new window
          newWindow.focus();
        } else {
          alert(
            "Popup blocked! Please allow popups for this site and try again."
          );
        }
      } catch (error) {
        console.error("Error opening voice agent:", error);
        alert(
          "Failed to open voice agent. Please check your browser settings."
        );
      }
    };

    const endVoiceAgent = () => {
      if (agentWindow && !agentWindow.closed) {
        agentWindow.close();
      }
      setIsCallActive(false);
      setAgentWindow(null);
    };

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6 -mt-16">
          {/* Circular waving design with blur effect */}
          <div className="relative mb-8">
            {/* Multiple overlapping circles for the waving effect */}
            <div className="absolute w-80 h-80 rounded-full bg-gradient-to-br from-green-600 via-pink-400 to-orange-500 opacity-70 animate-pulse"></div>
            <div
              className="absolute w-80 h-80 rounded-full bg-gradient-to-tr from-pink-400 via-orange-400 to-green-600 opacity-60 animate-pulse"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute w-80 h-80 rounded-full bg-gradient-to-bl from-orange-400 via-green-500 to-pink-500 opacity-50 animate-pulse"
              style={{ animationDelay: "1s" }}
            ></div>

            {/* Blur overlay */}
            <div className="absolute inset-0 w-80 h-80 rounded-full backdrop-blur-lg bg-white/10"></div>

            {/* Central Call AI agent button */}
            <div className="relative z-10 w-80 h-80 flex items-center justify-center">
              <button
                className={`flex items-center justify-center rounded-full shadow-xl text-gray-900 px-8 py-4 font-semibold transition-all duration-300 hover:shadow-2xl transform hover:scale-105 ${
                  isCallActive
                    ? "bg-green-500/90 text-white animate-pulse"
                    : "bg-white/90 backdrop-blur-md hover:bg-white/95"
                }`}
                onClick={startVoiceAgent}
                disabled={isCallActive}
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${
                    isCallActive ? "bg-white" : "bg-black"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 ${
                      isCallActive ? "text-green-500" : "text-white"
                    }`}
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                    <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                  </svg>
                </div>
                {isCallActive ? "AI Doctor Active..." : "Call AI Doctor"}
              </button>
            </div>
          </div>

          {/* Status indicator when call is active */}
          {isCallActive && (
            <div className="mb-4 flex flex-col items-center">
              <div className="flex items-center text-green-600 mb-2">
                <div className="w-3 h-3 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                <span className="text-sm font-medium">
                  AI Doctor is active in popup window
                </span>
              </div>
              <p className="text-xs text-gray-500 text-center">
                The AI Doctor has opened in a separate window. You can speak to
                it there.
              </p>
            </div>
          )}

          {/* End call button when active */}
          {isCallActive && (
            <button
              onClick={endVoiceAgent}
              className="mb-4 px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
            >
              Close Agent Window
            </button>
          )}

          {/* Book Appointment button below */}
          <button
            onClick={() => setCurrentPage("home")}
            className="px-12 py-4 bg-teal-600 text-white rounded-xl font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Back to Home
          </button>

          {/* Instructions */}
          <div className="mt-8 max-w-md text-center">
            <p className="text-sm text-gray-600">
              Click "Call AI Agent" to open the voice assistant in a new window.
              Make sure your browser allows popups for the best experience.
            </p>
          </div>
        </div>
      </div>
    );
  };

  // Book Appointment Page Component
  const BookAppointmentPage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="bg-gray-50 min-h-screen flex items-center justify-center py-10">
        <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-6xl">
          {/* Header */}
          <h2 className="text-2xl font-bold text-gray-800 mb-1">
            Book Your Appointment
          </h2>
          <p className="text-gray-500 mb-4">
            Select a doctor and available time slot
          </p>
          <hr className="mb-6" />

          {/* Doctor Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {doctors.map((doctor, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-xl p-5 text-center shadow-sm hover:shadow-md transition"
              >
                <img
                  src={doctor.image}
                  alt={doctor.name}
                  className="w-16 h-16 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-lg font-semibold text-gray-900">
                  {doctor.name}
                </h3>
                <p className="text-gray-500">{doctor.specialty}</p>
                <p className="flex items-center justify-center text-yellow-500 mt-1">
                  <span className="text-lg">★</span>
                  <span className="ml-1 text-gray-700 font-medium">
                    {doctor.rating.toFixed(1)}
                  </span>
                  <span className="ml-1 text-gray-500">
                    ({doctor.reviews} reviews)
                  </span>
                </p>

                {/* Time Slots */}
                <div className="flex flex-wrap gap-2 mt-4 justify-center">
                  {doctor.times.map((time, tIdx) => (
                    <button
                      key={tIdx}
                      onClick={() => handleSlotSelect(doctor, time)}
                      className={`border border-gray-300 rounded-md px-4 py-1 text-sm font-medium transition 
                        ${
                          selectedAppointment?.doctor === doctor.name &&
                          selectedAppointment?.time === time
                            ? "bg-blue-600 text-white border-blue-600"
                            : "hover:bg-blue-50 hover:border-blue-400"
                        }`}
                    >
                      {time}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Appointment Confirmation */}
          {selectedAppointment && (
            <div className="mt-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
              <h3 className="text-lg font-bold text-blue-800 mb-2">
                Appointment Confirmation
              </h3>
              <p className="text-gray-700">
                <strong>Doctor:</strong> {selectedAppointment.doctor}
              </p>
              <p className="text-gray-700">
                <strong>Time:</strong> {selectedAppointment.time}
              </p>
              <p className="text-gray-700">
                <strong>Date:</strong> {selectedAppointment.date}
              </p>
              <button
                onClick={() => alert("Appointment Confirmed!")}
                className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md font-medium hover:bg-blue-700 transition"
              >
                Confirm Appointment
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Home Page Component (Updated with Call Now onClick)
  const HomePage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {<FormattedMessage id="PatientDashboard.Welcomeback" />},
            <span className="text-teal-700">{mockUser.name.split(" ")[0]}</span>
          </h1>
          <p className="text-gray-600">
            {
              <FormattedMessage id="PatientDashboard.Howcanwehelpyouwithyourhealthtoday" />
            }
          </p>
        </div>

        {/* Main Action Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* Call Now Card - UPDATED with onClick */}
          <div
            //onClick={() => setCurrentPage("callnow")}
            onClick={startVoiceAgent}
            className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-8 hover:from-blue-500 hover:to-blue-600 transition-all duration-300 cursor-pointer group shadow-xl"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="flex items-center mb-4">
                  <Phone className="h-8 w-8 text-white mr-3" />
                  <h2 className="text-2xl font-bold text-white">
                    {<FormattedMessage id="PatientDashboard.CallNow" />}
                  </h2>
                </div>
                <p className="text-blue-100 mb-4">
                  {
                    <FormattedMessage id="PatientDashboard.ConnectinstantlywithAIhealthassistant" />
                  }
                </p>
                <div className="flex items-center text-blue-100 text-sm">
                  <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
                  {<FormattedMessage id="PatientDashboard.AIassistantonline" />}
                </div>
              </div>
              <Phone className="h-16 w-16 text-blue-200 group-hover:scale-110 transition-transform" />
            </div>
          </div>

          {/* Chat Card */}
          <div
            onClick={() => setCurrentPage("chat")}
            className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl p-8 hover:from-teal-500 hover:to-teal-600 transition-all duration-300 cursor-pointer group shadow-xl"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="flex items-center mb-4">
                  <MessageCircle className="h-8 w-8 text-white mr-3" />
                  <h2 className="text-2xl font-bold text-white">
                    {" "}
                    {<FormattedMessage id="PatientDashboard.Chat" />}
                  </h2>
                </div>
                <p className="text-teal-100 mb-4">
                  {
                    <FormattedMessage id="PatientDashboard.Describeyoursymptomsandgetinstantguidance" />
                  }
                </p>
                <div className="flex items-center text-teal-100 text-sm">
                  <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
                  {<FormattedMessage id="PatientDashboard.AIassistantonline" />}
                </div>
              </div>
              <MessageCircle className="h-16 w-16 text-teal-200 group-hover:scale-110 transition-transform" />
            </div>
          </div>
        </div>

        {/* Digital Health Card and Quick Actions */}
        <div className="grid lg:grid-cols-3 gap-6 mb-8">
          {/* Digital Health Card */}
          <div className="lg:col-span-2 bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-xl font-semibold text-gray-900">
                {<FormattedMessage id="PatientDashboard.DigitalHealthCard" />}
              </h3>
              <QrCode className="h-6 w-6 text-gray-500" />
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-gray-500">
                      {<FormattedMessage id="PatientDashboard.FullName" />}
                    </p>
                    <p className="text-gray-900 font-medium">{mockUser.name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">
                      {
                        <FormattedMessage id="PatientDashboard.MedicalRecordNumber" />
                      }
                    </p>
                    <p className="text-gray-900 font-medium">{mockUser.mrn}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">
                      {<FormattedMessage id="PatientDashboard.Phone" />}
                    </p>
                    <p className="text-gray-900 font-medium">
                      {mockUser.phone}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <div className="w-32 h-32 bg-gray-100 rounded-lg p-4 flex items-center justify-center border">
                  <QrCode className="w-full h-full text-gray-700" />
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <Download className="h-4 w-4 mr-2" />
                {<FormattedMessage id="Common.Download" />}
              </button>
              <button className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
                <Share className="h-4 w-4 mr-2" />
                {<FormattedMessage id="Common.Share" />}
              </button>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="space-y-4">
            <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer shadow-sm">
              <div
                className="flex items-center mb-3"
                onClick={() => setCurrentPage("chat")}
              >
                <Plus className="h-6 w-6 text-teal-400 mr-3" />
                <h4 className="font-semibold text-gray-900">
                  {
                    <FormattedMessage id="PatientDashboard.StartNewAssessment" />
                  }
                </h4>
              </div>
              <p className="text-gray-600 text-sm">
                {
                  <FormattedMessage id="PatientDashboard.Quickhealthscreening" />
                }
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer shadow-sm">
              <div className="flex items-center mb-3">
                <Calendar className="h-6 w-6 text-blue-400 mr-3" />
                <h4 className="font-semibold text-gray-900">
                  {<FormattedMessage id="PatientDashboard.NextAppointment" />}
                </h4>
              </div>
              <p className="text-gray-600 text-sm">Jan 20, 2:00 PM</p>
              <p className="text-gray-700 text-xs">Dr. Aisha Ibrahim</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer shadow-sm">
              <div
                className="flex items-center mb-3"
                onClick={() => setCurrentPage("appointments")}
              >
                <FileText className="h-6 w-6 text-purple-400 mr-3" />
                <h4 className="font-semibold text-gray-900">
                  {<FormattedMessage id="PatientDashboard.RecentVisits" />}
                </h4>
              </div>
              <p className="text-gray-600 text-sm">
                {<FormattedMessage id="PatientDashboard.Viewmedicalhistory" />}
              </p>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            {<FormattedMessage id="PatientDashboard.RecentActivity" />}
          </h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center">
                  <Check className="h-5 w-5 text-white" />
                </div>
                <div className="ml-4">
                  <p className="text-gray-900 font-medium">
                    {
                      <FormattedMessage id="PatientDashboard.Videoconsultationcompleted" />
                    }
                  </p>
                  <p className="text-gray-600 text-sm">
                    Dr. Mohamed Ali • Jan 15, 10:30 AM
                  </p>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </div>

            <div className="flex items-center justify-between py-3 border-b border-gray-200 last:border-b-0">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                  <FileText className="h-5 w-5 text-white" />
                </div>
                <div className="ml-4">
                  <p className="text-gray-900 font-medium">
                    {
                      <FormattedMessage id="PatientDashboard.Prescriptionreceived" />
                    }
                  </p>
                  <p className="text-gray-600 text-sm">
                    Medication for seasonal allergies
                  </p>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </div>
          </div>
        </div>
      </div>
      {showVoiceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <Phone className="h-4 w-4 text-green-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">
                  AI Doctor
                </h3>
              </div>
              <button
                onClick={closeVoiceModal}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            {/* Status */}
            <div className="text-center py-4">
              {isCallActive ? (
                <div>
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="w-6 h-6 bg-green-500 rounded-full animate-pulse"></div>
                  </div>
                  <h4 className="text-lg font-medium text-gray-900 mb-2">
                    AI Doctor Active
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Your AI voice assistant is running in a separate window. You
                    can speak to it there.
                  </p>
                  <button
                    onClick={endVoiceAgent}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
                  >
                    End Call
                  </button>
                </div>
              ) : (
                <div>
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Phone className="w-8 h-8 text-gray-400" />
                  </div>
                  <h4 className="text-lg font-medium text-gray-900 mb-2">
                    Call Ended
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Your voice session has ended.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // AI Chat Page Component (updated with video call button)
  const ChatPage = () => {
    const [chatMessages, setChatMessages] = useState([]);
    const [symptoms, setSymptoms] = useState("");
    const [sending, setSending] = useState(false);
    const [sessionId] = useState(() =>
      Math.floor(Math.random() * 10000).toString()
    );
    const chatContainerRef = useRef(null);
    const inputRef = useRef(null);

    // Speech-to-Text
    const {
      transcript,
      finalTranscript,
      interimTranscript,
      listening,
      resetTranscript,
      browserSupportsSpeechRecognition,
    } = useSpeechRecognition({
      clearTranscriptOnListen: false,
      continuous: true,
      interimResults: true,
    });

    // Text-to-Speech
    const [autoTTS, setAutoTTS] = useState(false);
    const [ttsSupported, setTtsSupported] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [voices, setVoices] = useState([]);
    const [voicesLoaded, setVoicesLoaded] = useState(false);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const currentUtterance = useRef(null);
    const speechTimeout = useRef(null);

    // Voice Selector
    const [showVoiceSelector, setShowVoiceSelector] = useState(false);
    const [previewingVoice, setPreviewingVoice] = useState(null);

    const n8nWebhookUrl =
      "https://n8n.techfeatured.com/webhook/register-patient";

    // Load voices on component mount
    useEffect(() => {
      if ("speechSynthesis" in window) {
        setTtsSupported(true);
        console.log("✅ Text-to-Speech supported");

        const loadVoices = () => {
          const availableVoices = window.speechSynthesis.getVoices();
          console.log("🔄 Loading voices, found:", availableVoices.length);

          if (availableVoices.length > 0) {
            setVoices(availableVoices);
            setVoicesLoaded(true);

            const workingVoices = availableVoices.filter(
              (v) => !v.localService
            );
            const fallbackVoices = availableVoices.filter((v) =>
              v.lang.includes("en")
            );

            const selected =
              workingVoices.find((v) => v.lang.includes("en")) ||
              fallbackVoices[0] ||
              availableVoices;

            setSelectedVoice(selected);
            console.log(
              "✅ Selected voice:",
              selected?.name,
              "LocalService:",
              selected?.localService
            );
          }
        };

        loadVoices();

        if (window.speechSynthesis.getVoices().length === 0) {
          console.log("⏳ Waiting for voices via onvoiceschanged...");
          window.speechSynthesis.onvoiceschanged = loadVoices;
        }
      }

      return () => {
        if (speechTimeout.current) clearTimeout(speechTimeout.current);
      };
    }, []);

    // Enhanced TTS function with delay fix
    const speakText = (text) => {
      if (!ttsSupported) {
        alert("Text-to-speech not supported in this browser.");
        return;
      }

      if (!voicesLoaded || !selectedVoice) {
        alert("Voices are still loading. Please wait a moment and try again.");
        return;
      }

      if (!text || text.trim() === "") {
        console.warn("No text to speak");
        return;
      }

      // Chrome workaround: Always cancel first
      window.speechSynthesis.cancel();
      setIsSpeaking(false);

      if (currentUtterance.current) {
        currentUtterance.current = null;
      }

      if (speechTimeout.current) {
        clearTimeout(speechTimeout.current);
        speechTimeout.current = null;
      }

      // Wait for cancel to complete
      setTimeout(() => {
        const utterance = new SpeechSynthesisUtterance(text.trim());

        utterance.voice = selectedVoice;
        utterance.rate = 1.0;
        utterance.pitch = 1.0;
        utterance.volume = 1.0;
        utterance.lang = selectedVoice.lang || "en-US";

        let hasStarted = false;

        const handleStart = (event) => {
          if (hasStarted) return;
          hasStarted = true;
          setIsSpeaking(true);
        };

        const handleEnd = (event) => {
          setIsSpeaking(false);
          currentUtterance.current = null;
        };

        const handleError = (event) => {
          setIsSpeaking(false);
          currentUtterance.current = null;
        };

        utterance.addEventListener("start", handleStart);
        utterance.addEventListener("end", handleEnd);
        utterance.addEventListener("error", handleError);

        utterance.onstart = handleStart;
        utterance.onend = handleEnd;
        utterance.onerror = handleError;

        currentUtterance.current = utterance;

        try {
          window.speechSynthesis.speak(utterance);
        } catch (error) {
          console.error("❌ Failed to start speech synthesis:", error);
          setIsSpeaking(false);
          currentUtterance.current = null;
          alert("Failed to start speech. Please refresh the page.");
        }
      }, 200);
    };

    const testTTS = () => {
      speakText("Hello! This is a test of the text to speech system.");
    };

    const stopSpeaking = () => {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
      currentUtterance.current = null;

      if (speechTimeout.current) {
        clearTimeout(speechTimeout.current);
        speechTimeout.current = null;
      }
    };

    const toggleAutoTTS = () => {
      const newAutoTTS = !autoTTS;
      setAutoTTS(newAutoTTS);

      if (!newAutoTTS && isSpeaking) {
        stopSpeaking();
      }
    };

    // Enhanced voice preview function with delay
    const previewVoice = (voice) => {
      // Cancel any existing speech first
      if (previewingVoice) {
        window.speechSynthesis.cancel();
        setPreviewingVoice(null);
      }

      // Add delay after cancel to ensure audio isn't blocked
      setTimeout(() => {
        setPreviewingVoice(voice);
        const utterance = new SpeechSynthesisUtterance(
          "Hello! This is how I sound. I can help you with your health questions."
        );

        // Set voice properties
        utterance.voice = voice;
        utterance.rate = 1.0;
        utterance.pitch = 1.0;
        utterance.volume = 1.0;
        utterance.lang = voice.lang || "en-US";

        // Add event handlers
        utterance.onstart = () => {
          console.log("Preview started for:", voice.name);
        };

        utterance.onend = () => {
          console.log("Preview ended for:", voice.name);
          setPreviewingVoice(null);
        };

        utterance.onerror = (event) => {
          console.error(
            "Preview error:",
            event.error,
            "for voice:",
            voice.name
          );
          setPreviewingVoice(null);
        };

        // Speak the utterance
        window.speechSynthesis.speak(utterance);
      }, 200); // 200ms delay to ensure cancel has completed
    };

    // Select voice function
    const selectVoice = (voice) => {
      setSelectedVoice(voice);
      setShowVoiceSelector(false);
      if (previewingVoice) {
        window.speechSynthesis.cancel();
        setPreviewingVoice(null);
      }
    };

    // Auto-TTS: Read new AI messages automatically
    useEffect(() => {
      if (autoTTS && ttsSupported && voicesLoaded && chatMessages.length > 0) {
        const lastMessage = chatMessages[chatMessages.length - 1];
        if (lastMessage.sender === "ai") {
          setTimeout(() => {
            speakText(lastMessage.text);
          }, 800);
        }
      }
    }, [chatMessages, autoTTS, ttsSupported, voicesLoaded]);

    // Update symptoms with final transcript
    useEffect(() => {
      if (finalTranscript) {
        setSymptoms((prev) => {
          const newContent = prev.trim()
            ? `${prev.trim()} ${finalTranscript}`
            : finalTranscript;
          return newContent;
        });
      }
    }, [finalTranscript]);

    // Auto-scroll effect
    useEffect(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, [chatMessages, sending]);

    // Auto-focus effect
    useEffect(() => {
      if (inputRef.current && !sending && !listening) {
        inputRef.current.focus();
      }
    }, [chatMessages, sending, listening]);

    // Enhanced Speech Recognition Functions
    const startListening = () => {
      if (!browserSupportsSpeechRecognition) {
        alert(
          "Speech recognition not supported. Please use Chrome, Edge, or Safari."
        );
        return;
      }

      // Stop TTS when starting to listen
      if (isSpeaking) {
        stopSpeaking();
      }

      resetTranscript();

      SpeechRecognition.startListening({
        continuous: true,
        language: "en-US",
        interimResults: true,
        maxAlternatives: 1,
        grammars: [],
      });
    };

    const stopListening = () => {
      SpeechRecognition.stopListening();
    };

    const toggleListening = () => {
      if (listening) {
        stopListening();
      } else {
        startListening();
      }
    };

    const handlePartialSpeech = () => {
      stopListening();
      setTimeout(() => {
        if (!sending) {
          startListening();
        }
      }, 100);
    };

    const clearAndRestartListening = () => {
      setSymptoms("");
      resetTranscript();
      if (listening) {
        stopListening();
        setTimeout(() => startListening(), 100);
      }
    };

    // Function to send message to n8n webhook
    const sendMessageToN8n = async (message) => {
      setSending(true);

      if (listening) {
        stopListening();
      }
      if (isSpeaking) {
        stopSpeaking();
      }

      const userMessage = {
        id: Date.now().toString(),
        text: message,
        sender: "user",
        timestamp: new Date(),
      };
      setChatMessages((prev) => [...prev, userMessage]);

      try {
        const response = await fetch(n8nWebhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chatInput: message,
            sessionId: sessionId,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const aiMessage = {
          id: (Date.now() + 1).toString(),
          text:
            data.reply ||
            data.response ||
            data.message ||
            data.output ||
            "I received your message but couldn't generate a response.",
          sender: "ai",
          timestamp: new Date(),
        };
        setChatMessages((prev) => [...prev, aiMessage]);
      } catch (error) {
        console.error("Error sending message to n8n:", error);

        const errorMessage = {
          id: (Date.now() + 1).toString(),
          text: "Sorry, I'm having trouble connecting right now. Please try again.",
          sender: "ai",
          timestamp: new Date(),
        };
        setChatMessages((prev) => [...prev, errorMessage]);
      } finally {
        setSending(false);
        resetTranscript();
      }
    };

    const handleSend = () => {
      if (symptoms.trim() && !sending) {
        sendMessageToN8n(symptoms.trim());
        setSymptoms("");
      }
    };

    const handleKeyPress = (e) => {
      if (e.key === "Enter" && symptoms.trim() && !sending) {
        handleSend();
      }
    };

    // Voice Selector Modal Component
    const VoiceSelector = () => {
      if (!showVoiceSelector) return null;

      return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">
                Choose Your Voice
              </h3>
              <button
                onClick={() => {
                  setShowVoiceSelector(false);
                  if (previewingVoice) {
                    window.speechSynthesis.cancel();
                    setPreviewingVoice(null);
                  }
                }}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ×
              </button>
            </div>

            <div className="p-6 overflow-y-auto max-h-[60vh]">
              <div className="grid gap-3">
                {voices.map((voice, index) => (
                  <div
                    key={index}
                    className={`border rounded-xl p-4 transition-all cursor-pointer ${
                      selectedVoice?.name === voice.name
                        ? "border-teal-500 bg-teal-50"
                        : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <div className="font-semibold text-gray-900">
                          {voice.name}
                        </div>
                        <div className="text-sm text-gray-600">
                          {voice.lang} •{" "}
                          {voice.localService ? "Local" : "Online"}
                        </div>
                      </div>

                      <div className="flex items-center gap-2">
                        {selectedVoice?.name === voice.name && (
                          <span className="px-2 py-1 bg-teal-100 text-teal-800 text-xs font-medium rounded-lg">
                            Selected
                          </span>
                        )}

                        <button
                          onClick={() => previewVoice(voice)}
                          disabled={previewingVoice === voice}
                          className={`px-3 py-1 rounded-lg text-sm font-medium transition-colors ${
                            previewingVoice === voice
                              ? "bg-blue-100 text-blue-800"
                              : "bg-blue-600 text-white hover:bg-blue-700"
                          }`}
                        >
                          {previewingVoice === voice ? (
                            <Loader2 className="h-4 w-4 animate-spin inline-block align-middle" />
                          ) : (
                            "🔊 Preview"
                          )}
                        </button>

                        <button
                          onClick={() => selectVoice(voice)}
                          className="px-3 py-1 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors"
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
              <p className="text-sm text-gray-600">
                💡 Click "Preview" to hear how each voice sounds, then click
                "Select" to choose your preferred voice.
              </p>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="flex flex-col lg:flex-row justify-center items-start max-w-screen-2xl mx-auto px-4 py-6 gap-8">
          {/* MAIN CHAT - OPTIMIZED DIMENSIONS */}
          <div className="flex-1 min-w-[600px] max-w-[1400px] bg-white shadow-xl rounded-3xl flex flex-col h-[88vh] relative overflow-hidden">
            {/* Chat Header - REDUCED HEIGHT */}
            <div className="px-4 py-3 flex items-center justify-between border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <span className="text-teal-600">
                  <Mic className="h-5 w-5 inline-block" />
                </span>
                {<FormattedMessage id="PatientChat.HealthAssistant" />}
              </h2>
              <div className="flex items-center gap-2">
                {/* Voice Selector Button */}
                {/* {ttsSupported && voicesLoaded && (
                  <button
                    onClick={() => setShowVoiceSelector(true)}
                    className="px-2 py-1.5 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-700 transition text-xs font-medium"
                  >
                    🎤 Choose Voice ({voices.length})
                  </button>
                )} */}

                {/* Test TTS Button */}
                {ttsSupported && (
                  <button
                    onClick={testTTS}
                    disabled={!voicesLoaded || isSpeaking}
                    className="px-2 py-1.5 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition disabled:opacity-60 text-xs"
                  >
                    {isSpeaking ? (
                      <Loader2 className="h-4 w-4 animate-spin inline-block align-middle" />
                    ) : (
                      "🔊 Test TTS"
                    )}
                  </button>
                )}

                {/* Auto-TTS Toggle Button */}
                {ttsSupported && voicesLoaded && (
                  <button
                    onClick={toggleAutoTTS}
                    className={`p-1.5 rounded-lg transition-colors ${
                      autoTTS
                        ? "bg-green-100 text-green-600 hover:bg-green-200"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                    title={
                      autoTTS ? "Disable auto-speech" : "Enable auto-speech"
                    }
                  >
                    {autoTTS ? (
                      <Volume2 className="h-5 w-5" />
                    ) : (
                      <VolumeX className="h-5 w-5" />
                    )}
                  </button>
                )}

                {/* Stop Speech Button */}
                {isSpeaking && (
                  <button
                    onClick={stopSpeaking}
                    className="p-1 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition-colors"
                    title="Stop speaking"
                  >
                    <VolumeX className="h-5 w-5" />
                  </button>
                )}
              </div>
            </div>

            {/* Chat Messages - MAXIMIZED SPACE */}
            <div
              ref={chatContainerRef}
              className="flex-1 overflow-y-auto p-5 space-y-4 scrollbar-thin scrollbar-thumb-teal-300 scrollbar-track-gray-200"
            >
              {/* Welcome msg */}
              <div className="flex items-start gap-2">
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
                  <MessageCircle className="h-4 w-4 text-white" />
                </div>
                <div className="bg-gray-100 rounded-xl p-4 max-w-xl">
                  <span className="text-gray-900 text-lg">
                    Hello! I'm your personal health assistant powered by
                    advanced medical knowledge.
                    <br />
                    <span className="font-semibold">
                      What's bothering you today?
                    </span>
                  </span>
                  {ttsSupported && voicesLoaded && (
                    <div className="mt-2">
                      <button
                        onClick={() =>
                          speakText(
                            "Hello! I'm your personal health assistant powered by advanced medical knowledge. What's bothering you today?"
                          )
                        }
                        disabled={isSpeaking}
                        className="flex items-center px-3 py-1 bg-teal-100 text-teal-700 rounded-md text-sm hover:bg-teal-200 transition-colors disabled:opacity-50"
                      >
                        <Volume2 className="h-4 w-4 mr-1" />
                        {isSpeaking ? "Speaking..." : "Listen"}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Chat log */}
              {chatMessages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${
                    message.sender === "user"
                      ? "justify-end"
                      : "items-start gap-2"
                  }`}
                >
                  {message.sender === "ai" && (
                    <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
                      <MessageCircle className="h-4 w-4 text-white" />
                    </div>
                  )}
                  <div
                    className={`rounded-xl px-4 py-3 max-w-xl text-lg ${
                      message.sender === "user"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100 text-gray-900"
                    }`}
                  >
                    <span>{message.text}</span>
                    {/* Listen button for AI messages */}
                    {message.sender === "ai" &&
                      ttsSupported &&
                      voicesLoaded && (
                        <div className="mt-2">
                          <button
                            onClick={() => speakText(message.text)}
                            disabled={isSpeaking}
                            className="flex items-center px-3 py-1 bg-teal-600 text-white rounded-md text-sm hover:bg-teal-700 transition-colors disabled:opacity-50"
                          >
                            <Volume2 className="h-4 w-4 mr-1" />
                            {isSpeaking ? "Speaking..." : "Listen"}
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              ))}

              {/* Typing indicator with dots */}
              {sending && (
                <div className="flex items-start gap-2">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
                    <MessageCircle className="h-4 w-4 text-white" />
                  </div>
                  <div className="bg-gray-100 rounded-xl p-4 max-w-xl">
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"></div>
                      <div
                        className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                        style={{ animationDelay: "0.1s" }}
                      ></div>
                      <div
                        className="w-2 h-2 bg-gray-500 rounded-full animate-bounce"
                        style={{ animationDelay: "0.2s" }}
                      ></div>
                    </div>
                  </div>
                </div>
              )}

              {/* Empty state */}
              {chatMessages.length === 0 && !sending && (
                <div className="text-center py-8">
                  <MessageCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-600 text-xl">
                    {
                      <FormattedMessage id="PatientChat.Startbydescribingyoursymptoms" />
                    }
                    ...
                  </p>
                  <p className="text-gray-500 text-base mt-2">
                    💡 {<FormattedMessage id="PatientChat.InputInfo" />}
                  </p>
                </div>
              )}
            </div>

            {/* Input bar - REDUCED PADDING */}
            <div className="p-2 border-t border-gray-100 bg-white flex gap-2 items-center">
              <input
                ref={inputRef}
                autoFocus
                type="text"
                value={symptoms}
                onChange={(e) => setSymptoms(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={
                  listening
                    ? "Listening... Speak clearly and pause between sentences"
                    : "Describe your symptoms or click mic to speak..."
                }
                className={`flex-1 px-3 py-3 rounded-lg border-2 border-gray-200 text-sm focus:border-teal-500 transition ${
                  listening ? "border-red-300 bg-red-50" : "border-gray-200"
                }`}
                disabled={sending}
              />
              {browserSupportsSpeechRecognition ? (
                <button
                  type="button"
                  onClick={toggleListening}
                  disabled={sending}
                  className={`p-2 rounded-lg text-sm transition-colors ${
                    listening
                      ? "bg-red-100 text-red-600 hover:bg-red-200"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  } disabled:opacity-50 disabled:cursor-not-allowed`}
                  title={listening ? "Stop listening" : "Start voice input"}
                >
                  {listening ? (
                    <MicOff className="h-5 w-5" />
                  ) : (
                    <Mic className="h-5 w-5" />
                  )}
                </button>
              ) : (
                <div
                  className="p-2 text-gray-400"
                  title="Voice input not supported in this browser"
                >
                  <Mic className="h-5 w-5" />
                </div>
              )}
              <button
                type="button"
                onClick={handleSend}
                disabled={sending || !symptoms.trim()}
                className="bg-teal-600 hover:bg-teal-700 text-white px-5 py-2 text-sm font-semibold rounded-lg shadow transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sending ? (
                  <Loader2 className="h-4 w-4 animate-spin inline-block align-middle" />
                ) : (
                  <FormattedMessage id="PatientChat.Send" />
                )}
              </button>
            </div>

            {/* Voice Controls and Status - REDUCED PADDING */}
            <div className="flex flex-wrap items-center gap-2 px-4 py-2 bg-white border-t border-gray-100">
              <button
                type="button"
                onClick={clearAndRestartListening}
                disabled={sending}
                className="px-2 py-1 bg-orange-100 text-orange-700 rounded-lg text-xs hover:bg-orange-200 transition-colors disabled:opacity-50"
              >
                {<FormattedMessage id="PatientChat.ClearRetry" />}
              </button>
              {listening && interimTranscript && (
                <button
                  type="button"
                  onClick={handlePartialSpeech}
                  className="px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs hover:bg-blue-200 transition-colors"
                >
                  {<FormattedMessage id="PatientChat.FinishSentence" />}
                </button>
              )}
              {interimTranscript && (
                <span className="text-xs text-gray-500 ml-2">
                  {<FormattedMessage id="PatientChat.Live" />}: "
                  {interimTranscript}"
                </span>
              )}

              {/* Status indicators */}
              {browserSupportsSpeechRecognition ? (
                <span className="text-green-600 flex items-center gap-1 text-xs">
                  <span className="w-2 h-2 bg-green-600 rounded-full inline-block"></span>{" "}
                  {<FormattedMessage id="PatientChat.Voiceinputready" />}
                </span>
              ) : (
                <span className="text-amber-600 text-xs">
                  ⚠️ Voice input not supported
                </span>
              )}

              {ttsSupported && voicesLoaded ? (
                <span className="text-blue-600 flex items-center gap-1 text-xs">
                  <span className="w-2 h-2 bg-blue-600 rounded-full inline-block"></span>{" "}
                  {<FormattedMessage id="PatientChat.TTSready" />}
                </span>
              ) : (
                <span className="text-amber-600 text-xs">
                  {ttsSupported
                    ? "⏳ Loading voices..."
                    : "⚠️ TTS not supported"}
                </span>
              )}

              {isSpeaking && (
                <span className="flex items-center gap-1 text-blue-600 text-xs">
                  <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse inline-block"></span>
                  Speaking...
                </span>
              )}

              {listening && (
                <span className="flex items-center gap-1 text-red-600 text-xs">
                  <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse inline-block"></span>
                  Listening...
                </span>
              )}
            </div>
          </div>

          {/* MODERN SIDEBAR - REDUCED SIZE */}
          <aside className="w-full max-w-sm hidden lg:flex flex-col gap-6">
            <div className="bg-gradient-to-tr from-blue-700 via-teal-500 to-blue-400 p-0 rounded-3xl shadow-lg">
              <div className="flex items-center px-5 py-4 rounded-t-3xl bg-blue-700">
                <Volume2 className="h-5 w-5 text-white mr-3" />
                <span className="text-white text-lg font-semibold tracking-wide">
                  {<FormattedMessage id="PatientChat.VoiceSpeechStatus" />}
                </span>
              </div>
              <div className="bg-white rounded-b-3xl px-5 py-6">
                <div className="flex items-center gap-2 mb-3">
                  <span
                    className={`inline-block h-3 w-3 rounded-full ${
                      ttsSupported && voicesLoaded
                        ? "bg-green-500"
                        : "bg-yellow-400"
                    } mr-2`}
                  />
                  <span className="font-bold text-base text-teal-700">
                    {ttsSupported && voicesLoaded
                      ? "Ready"
                      : ttsSupported
                      ? "Loading voices..."
                      : "Not Supported"}
                  </span>
                </div>
                <div className="text-gray-800 mb-2 text-sm">
                  <span className="font-semibold">Voice:</span>{" "}
                  <span className="text-teal-600">
                    {selectedVoice?.name || "None"}
                  </span>
                  <span className="ml-2 text-xs text-gray-400">
                    ({voices.length} voices)
                  </span>
                </div>

                <div className="text-gray-800 mb-3 text-sm">
                  <span className="font-semibold">Auto-TTS:</span>
                  <span
                    className={`ml-2 px-2 py-1 rounded-lg text-xs font-bold ${
                      autoTTS
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {autoTTS ? "ON" : "OFF"}
                  </span>
                </div>

                <hr className="my-4" />
                <div className="mb-4">
                  <span className="font-semibold text-blue-700 text-sm">
                    {<FormattedMessage id="PatientChat.SpeechTips" />}:
                  </span>
                  <ul className="mt-2 ml-4 text-gray-700 list-disc space-y-1 text-sm">
                    <li>
                      <FormattedMessage id="PatientChat.SpeakClearly" />
                    </li>
                    <li>
                      <FormattedMessage id="PatientChat.PauseBetweenSentences" />
                    </li>
                    <li>
                      <FormattedMessage id="PatientChat.QuietMic" />
                    </li>
                    <li>
                      <span className="bg-orange-100 px-2 py-1 rounded-lg font-semibold text-orange-800">
                        <FormattedMessage id="PatientChat.ClearRetry" />
                      </span>{" "}
                      <FormattedMessage id="PatientChat.RecognitionOff" />
                    </li>
                  </ul>
                </div>
                <div>
                  <span className="font-semibold text-teal-800 text-sm">
                    <FormattedMessage id="PatientChat.TTSInstructions" />
                  </span>
                  <ul className="mt-2 ml-4 list-disc text-sm text-gray-800 space-y-1">
                    <li>
                      <span className="bg-blue-600 text-white px-2 py-0.5 rounded-lg">
                        <FormattedMessage id="PatientChat.TestTTS" />
                      </span>{" "}
                      <FormattedMessage id="PatientChat.VerifyAudio" />
                    </li>
                    <li>
                      <span className="bg-teal-600 text-white px-2 py-0.5 rounded-lg">
                        <FormattedMessage id="PatientChat.Listen" />
                      </span>{" "}
                      <FormattedMessage id="PatientChat.OnEachResponse" />
                    </li>
                    <li>
                      <FormattedMessage id="PatientChat.Toggle" />{" "}
                      <Volume2 className="h-4 w-4 inline" />/
                      <VolumeX className="h-4 w-4 inline" />{" "}
                      <FormattedMessage id="PatientChat.AutoReading" />
                    </li>
                    <li>
                      <FormattedMessage id="PatientChat.CheckPermissions" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </aside>
        </div>

        {/* Action Buttons - REDUCED PADDING */}
        <div className="max-w-screen-2xl mx-auto px-4 pb-6">
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => setCurrentPage("home")}
              className="flex items-center px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm"
            >
              <FormattedMessage id="PatientChat.BackToHome" />
            </button>
            <button
              type="button"
              onClick={() => {
                localStorage.setItem(
                  "chatHistory",
                  JSON.stringify(chatMessages)
                );
                setCurrentPage("home");
              }}
              className="flex items-center px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm"
            >
              <FileText className="h-4 w-4 mr-2" />
              <FormattedMessage id="PatientChat.SaveExit" />
            </button>
          </div>
        </div>

        {/* Voice Selector Modal */}
        <VoiceSelector />
      </div>
    );
  };

  const filtered =
    filter === "all"
      ? mockAppointments
      : mockAppointments.filter((a) => a.status === filter);

  // Appointments Page Component (updated with View Summary button)
  const AppointmentsPage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            {<FormattedMessage id="PatientAppointment.Appointments" />}
          </h1>
          <button
            onClick={() => setCurrentPage("bookappointment")}
            className="flex items-center px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
          >
            <Plus className="h-4 w-4 mr-2" />
            {<FormattedMessage id="PatientAppointment.BookNewAppointment" />}
          </button>
        </div>

        {/* Filters */}
        {/* <div className="flex space-x-4 mb-6">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg">
            All
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
            Upcoming
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
            Past
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
            Cancelled
          </button>
        </div> */}
        <div className="flex space-x-4 mb-6 overflow-x-auto">
          {[
            {
              label: <FormattedMessage id="PatientAppointment.All" />,
              value: "all",
            },
            {
              label: <FormattedMessage id="PatientAppointment.Upcoming" />,
              value: "Upcoming",
            },
            {
              label: <FormattedMessage id="PatientAppointment.Completed" />,
              value: "Completed",
            },
          ].map((f) => (
            <button
              key={f.value}
              onClick={() => setFilter(f.value)}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filter === f.value
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Appointments List - UPDATED with View Summary */}
        <div className="space-y-4">
          {filtered.map((appointment) => (
            <div
              key={appointment.id}
              className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                    {appointment.consultationType === "Video" && (
                      <Video className="h-6 w-6 text-white" />
                    )}
                    {appointment.consultationType === "Chat" && (
                      <MessageCircle className="h-6 w-6 text-white" />
                    )}
                    {appointment.consultationType === "Phone" && (
                      <Phone className="h-6 w-6 text-white" />
                    )}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {generateRandomDoctor(appointment.id)}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {new Date(
                        appointment.appointmentDateTime
                      ).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      })}{" "}
                      at{" "}
                      {new Date(
                        appointment.appointmentDateTime
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </p>
                    <div className="flex items-center mt-1">
                      <span
                        className={`px-4 py-1 rounded-full text-xs ${
                          appointment.status === "Upcoming"
                            ? "bg-green-900 text-white"
                            : appointment.status === "Completed"
                            ? "bg-blue-900 text-white"
                            : "bg-red-900 text-white"
                        }`}
                      >
                        {appointment.status.charAt(0).toUpperCase() +
                          appointment.status.slice(1)}
                      </span>
                      <span className="ml-2 text-xs text-gray-500 capitalize">
                        {appointment.consultationType} Consultation
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2">
                  {appointment.status === "Upcoming" && (
                    <>
                      <button
                        onClick={startVideoCall}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      >
                        {<FormattedMessage id="PatientAppointment.Join" />}
                      </button>
                      <button className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
                        {
                          <FormattedMessage id="PatientAppointment.Reschedule" />
                        }
                      </button>
                      <button
                        onClick={() => {
                          setCurrentPage("summary");
                          callAppointmentDetails(appointment.id);
                        }}
                        className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
                      >
                        {
                          <FormattedMessage id="PatientAppointment.ViewSummary" />
                        }
                      </button>
                    </>
                  )}
                  {appointment.status === "Completed" && (
                    <button
                      onClick={() => {
                        setCurrentPage("summary");
                        callAppointmentDetails(appointment.id);
                      }}
                      className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
                    >
                      {<FormattedMessage id="PatientAppointment.ViewSummary" />}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // Health Records Page Component (unchanged)
  const RecordsPage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            {<FormattedMessage id="PatientDashboard.HealthRecords" />}
          </h1>
          <div className="flex space-x-3">
            <button className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
              <Search className="h-4 w-4 mr-2" />
              {<FormattedMessage id="Common.Search" />}
            </button>
            <button className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
              <Filter className="h-4 w-4 mr-2" />
              {<FormattedMessage id="Common.Filter" />}
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 mb-8">
          <nav className="flex space-x-8">
            <button className="py-2 px-1 border-b-2 border-teal-400 text-teal-400 font-medium">
              {<FormattedMessage id="PatientHealthRecords.Prescriptions" />}
            </button>
            <button className="py-2 px-1 text-gray-600 hover:text-gray-900">
              {<FormattedMessage id="PatientHealthRecords.LabResults" />}
            </button>
            <button className="py-2 px-1 text-gray-600 hover:text-gray-900">
              {<FormattedMessage id="PatientHealthRecords.Documents" />}
            </button>
            <button className="py-2 px-1 text-gray-600 hover:text-gray-900">
              {<FormattedMessage id="PatientHealthRecords.AIAssessments" />}
            </button>
          </nav>
        </div>

        {/* Records Content */}
        <div className="space-y-6">
          {/* Recent Prescription */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mr-4">
                  <FileText className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {
                      <FormattedMessage id="PatientHealthRecords.SeasonalAllergyMedication" />
                    }
                  </h3>
                  <p className="text-gray-600 mb-2">
                    {
                      <FormattedMessage id="PatientHealthRecords.Prescribedby" />
                    }{" "}
                    Dr. Mohamed Ali
                  </p>
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>Jan 15, 2024</span>
                    <span>•</span>
                    <span>
                      <FormattedMessage id="PatientHealthRecords.30-daysupply" />
                    </span>
                    <span>•</span>
                    <span className="text-green-400">
                      <FormattedMessage id="PatientHealthRecords.Active" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-2">
                <button className="flex items-center px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm">
                  <Download className="h-4 w-4 mr-1" />
                  {<FormattedMessage id="Common.Download" />}
                </button>
                {/* <button className="flex items-center px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm">
                  <Share className="h-4 w-4 mr-1" />
                  {<FormattedMessage id="Common.Share" />}
                </button> */}
              </div>
            </div>
          </div>

          {/* Lab Results */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mr-4">
                  <FileText className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {
                      <FormattedMessage id="PatientHealthRecords.BloodWorkPanel" />
                    }
                  </h3>
                  <p className="text-gray-600 mb-2">
                    {
                      <FormattedMessage id="PatientHealthRecords.Prescribedby" />
                    }{" "}
                    Dr. Aisha Ibrahim
                  </p>
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>Jan 10, 2024</span>
                    <span>•</span>
                    <span>
                      <FormattedMessage id="PatientHealthRecords.CompleteBloodCount" />
                    </span>
                    <span>•</span>
                    <span className="text-yellow-400">
                      <FormattedMessage id="PatientHealthRecords.ResultsPending" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-2">
                <button className="flex items-center px-3 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed text-sm">
                  <Clock className="h-4 w-4 mr-1" />
                  <FormattedMessage id="PatientHealthRecords.Pending" />
                </button>
              </div>
            </div>
          </div>

          {/* AI Assessment */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4">
                  <MessageCircle className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    {
                      <FormattedMessage id="PatientHealthRecords.AISymptomAssessment" />
                    }
                  </h3>
                  <p className="text-gray-600 mb-2">
                    {
                      <FormattedMessage id="PatientHealthRecords.Cold&flusymptomsscreening" />
                    }
                  </p>
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>Jan 8, 2024</span>
                    <span>•</span>
                    <span>
                      <FormattedMessage id="PatientHealthRecords.Lowriskassessment" />
                    </span>
                    <span>•</span>
                    <span className="text-green-400">
                      {<FormattedMessage id="PatientAppointment.Completed" />}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-2">
                <button className="flex items-center px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm">
                  <FileText className="h-4 w-4 mr-1" />
                  {<FormattedMessage id="Common.ViewReport" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Profile Page Component (unchanged)
  const ProfilePage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Profile & Settings
        </h1>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Profile Info */}
          <div className="md:col-span-2 space-y-6">
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">
                Personal Information
              </h2>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Full Name
                  </label>
                  <input
                    type="text"
                    defaultValue={mockUser.name}
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    defaultValue={mockUser.email}
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    defaultValue={mockUser.phone}
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
              </div>

              <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors">
                Save Changes
              </button>
            </div>

            {/* Emergency Contact */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">
                Emergency Contact
              </h2>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Contact Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter emergency contact name"
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Relationship
                  </label>
                  <select className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400">
                    <option>Select relationship</option>
                    <option>Spouse</option>
                    <option>Parent</option>
                    <option>Sibling</option>
                    <option>Child</option>
                    <option>Friend</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    placeholder="Enter phone number"
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-400"
                  />
                </div>
              </div>

              <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors">
                Save Emergency Contact
              </button>
            </div>
          </div>

          {/* Settings Sidebar */}
          <div className="space-y-6">
            {/* Language Settings */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Language
              </h3>
              <div className="space-y-3">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="language"
                    value="en"
                    checked={language === "en-US"}
                    onChange={(e) => setLanguage(e.target.value)}
                    className="mr-3"
                  />
                  <span className="text-gray-700">English</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="language"
                    value="dv"
                    checked={language === "dh-ML"}
                    onChange={(e) => setLanguage(e.target.value)}
                    className="mr-3"
                  />
                  <span className="text-gray-700">Dhivehi</span>
                </label>
              </div>
            </div>

            {/* Notifications */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Notifications
              </h3>
              <div className="space-y-4">
                <label className="flex items-center justify-between">
                  <span className="text-gray-700">Appointment reminders</span>
                  <input type="checkbox" defaultChecked className="rounded" />
                </label>
                <label className="flex items-center justify-between">
                  <span className="text-gray-700">Prescription alerts</span>
                  <input type="checkbox" defaultChecked className="rounded" />
                </label>
                <label className="flex items-center justify-between">
                  <span className="text-gray-700">Health tips</span>
                  <input type="checkbox" className="rounded" />
                </label>
              </div>
            </div>

            {/* Privacy */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Privacy & Security
              </h3>
              <div className="space-y-3">
                <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  Privacy Policy
                </button>
                <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  Data & Consent
                </button>
                <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  Two-Factor Auth
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // Mental Health Coming Soon Page Component
  // Mental Health Page Component
  const MentalHealthPage = () => {
    const [startingAssessment, setStartingAssessment] = useState(false);

    const mentalHealthTips = [
      {
        icon: "🧠",
        title: (
          <FormattedMessage id="PatientMentalHealth.PracticeMindfulness" />
        ),
        description: (
          <FormattedMessage id="PatientMentalHealth.Takeafewminuteseachdaytofocusonyourbreathingandbepresentinthemoment." />
        ),
        color: "teal",
      },
      {
        icon: "💪",
        title: (
          <FormattedMessage id="PatientMentalHealth.StayPhysicallyActive" />
        ),
        description: (
          <FormattedMessage id="PatientMentalHealth.Regularexercisereleasesendorphins" />
        ),
        color: "blue",
      },
      {
        icon: "😴",
        title: <FormattedMessage id="PatientMentalHealth.PrioritizeSleep" />,
        description: (
          <FormattedMessage id="PatientMentalHealth.Qualitysleepisessentialformentalhealth." />
        ),
        color: "purple",
      },
      {
        icon: "🤝",
        title: <FormattedMessage id="PatientMentalHealth.ConnectwithOthers" />,
        description: (
          <FormattedMessage id="PatientMentalHealth.Buildingstrongrelationships" />
        ),
        color: "green",
      },
    ];

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <div className="mb-6">
              <span className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-teal-500 to-blue-600 rounded-full">
                <Heart className="h-10 w-10 text-white" />
              </span>
            </div>
            <h1 className="text-5xl font-extrabold text-gray-900 mb-4">
              {<FormattedMessage id="PatientMentalHealth.YourMentalHealth" />}
              <span className="text-teal-600">
                {<FormattedMessage id="PatientMentalHealth.Matters" />}
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {
                <FormattedMessage id="PatientMentalHealth.TakecareofyourmindwithourAI-powered" />
              }
            </p>
          </div>

          {/* Importance Cards */}
          <div className="grid gap-8 md:grid-cols-3 mb-16">
            {/* Mental Health Importance */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="mb-6">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
                  <Heart className="h-8 w-8 text-teal-600" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {
                  <FormattedMessage id="PatientMentalHealth.MentalHealthisHealth" />
                }
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {
                  <FormattedMessage id="PatientMentalHealth.Yourmentalhealthisjustasimportantasyourphysicalhealth." />
                }
              </p>
            </div>

            {/* Common Challenges */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="mb-6">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                  <MessageCircle className="h-8 w-8 text-purple-600" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {<FormattedMessage id="PatientMentalHealth.You'reNotAlone" />}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {
                  <FormattedMessage id="PatientMentalHealth.Anxiety,depression,andstressarecommonexperiences." />
                }
              </p>
            </div>

            {/* Getting Help */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                  <Users className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {
                  <FormattedMessage id="PatientMentalHealth.SeekingHelpisStrength" />
                }
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {
                  <FormattedMessage id="PatientMentalHealth.Reachingoutforsupportisacourageoussteptowardhealing." />
                }
              </p>
            </div>
          </div>

          {/* Mental Health Tips Section */}
          <div className="mb-16">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                {
                  <FormattedMessage id="PatientMentalHealth.DailyMentalHealthTips" />
                }
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                {
                  <FormattedMessage id="PatientMentalHealth.Simplepracticesyoucanincorporateintoyourdailyroutine" />
                }
              </p>
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
              {mentalHealthTips.map((tip, index) => (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100"
                >
                  <div className="text-center mb-4">
                    <span className="text-4xl">{tip.icon}</span>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3 text-center">
                    {tip.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed text-center">
                    {tip.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Statistics Section */}
          <div className="bg-gradient-to-r from-teal-600 to-blue-600 rounded-2xl p-8 mb-16 text-white">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-4">
                {
                  <FormattedMessage id="PatientMentalHealth.MentalHealthbytheNumbers" />
                }
              </h2>
              <p className="text-teal-100 text-lg">
                {
                  <FormattedMessage id="PatientMentalHealth.Understandingtheimportanceofmentalhealthawareness" />
                }
              </p>
            </div>

            <div className="grid gap-8 md:grid-cols-3 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">1 in 4</div>
                <p className="text-teal-100">
                  {
                    <FormattedMessage id="PatientMentalHealth.peopleexperiencementalhealthissueseachyear" />
                  }
                </p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">75%</div>
                <p className="text-teal-100">
                  {
                    <FormattedMessage id="PatientMentalHealth.ofmentalhealthconditionsdevelopbeforeage24" />
                  }
                </p>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">80%</div>
                <p className="text-teal-100">
                  {
                    <FormattedMessage id="PatientMentalHealth.ofpeoplecanrecoverwithpropertreatmentandsupport" />
                  }
                </p>
              </div>
            </div>
          </div>

          {/* Assessment CTA Section */}
          <div className="bg-white rounded-2xl shadow-xl p-12 text-center border border-gray-100">
            <div className="mb-8">
              <div className="w-20 h-20 bg-gradient-to-r from-teal-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <FileText className="h-10 w-10 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                {
                  <FormattedMessage id="PatientMentalHealth.ReadytoTaketheFirstStep?" />
                }
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
                {
                  <FormattedMessage id="PatientMentalHealth.OurAI-poweredmentalhealthassessment" />
                }
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => {
                  setStartingAssessment(true);
                  setTimeout(() => {
                    alert(
                      "Mental Health Assessment feature is coming soon! Our team is working to provide you with comprehensive mental health screening tools."
                    );
                    setStartingAssessment(false);
                  }, 1000);
                }}
                disabled={startingAssessment}
                className={`px-8 py-4 rounded-xl text-lg font-semibold transition-all duration-300 ${
                  startingAssessment
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-gradient-to-r from-teal-600 to-blue-600 text-white hover:from-teal-700 hover:to-blue-700 transform hover:scale-105 shadow-lg hover:shadow-xl"
                }`}
              >
                {startingAssessment ? (
                  <span className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-200"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    {
                      <FormattedMessage id="PatientMentalHealth.StartingAssessment..." />
                    }
                  </span>
                ) : (
                  <FormattedMessage id="PatientMentalHealth.StartYourAssessment" />
                )}
              </button>

              <button
                onClick={() => setCurrentPage("chat")}
                className="px-8 py-4 bg-gray-100 text-gray-700 rounded-xl text-lg font-semibold hover:bg-gray-200 transition-all duration-300"
              >
                {
                  <FormattedMessage id="PatientMentalHealth.TalktoAIAssistant" />
                }
              </button>
            </div>

            <p className="text-sm text-gray-500 mt-6">
              {
                <FormattedMessage id="PatientMentalHealth.Confidential•Secure" />
              }
            </p>
          </div>

          {/* Emergency Section */}
          <div className="mt-16 bg-red-50 border border-red-200 rounded-xl p-8 text-center">
            <div className="mb-4">
              <AlertTriangle className="h-12 w-12 text-red-600 mx-auto" />
            </div>
            <h3 className="text-2xl font-bold text-red-900 mb-4">
              {<FormattedMessage id="PatientMentalHealth.NeedImmediateHelp?" />}
            </h3>
            <p className="text-red-800 mb-6">
              {
                <FormattedMessage id="PatientMentalHealth.Ifyou'reexperiencingamentalhealthemergencyorhaving" />
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors">
                {
                  <FormattedMessage id="PatientMentalHealth.EmergencyHotline:911" />
                }
              </button>
              {/* <button className="px-6 py-3 bg-white text-red-600 border border-red-300 rounded-lg font-semibold hover:bg-red-50 transition-colors">
                Crisis Text Line
              </button> */}
            </div>
          </div>
        </main>
      </div>
    );
  };

  // const MentalHealthPage = () => (
  //   <div className="min-h-screen bg-gray-50">
  //     <Navigation />
  //     <div className="min-h-screen bg-gradient-to-b from-teal-50 to-blue-100 flex flex-col items-center justify-center px-4">
  //       <div className="bg-white/80 p-10 rounded-2xl shadow-xl max-w-lg w-full text-center border border-blue-100">
  //         <div className="mx-auto mb-6 flex justify-center">
  //           <span className="inline-flex items-center justify-center bg-teal-200 rounded-full w-20 h-20">
  //             <svg
  //               className="h-12 w-12 text-teal-600"
  //               fill="none"
  //               stroke="currentColor"
  //               strokeWidth={1.5}
  //               viewBox="0 0 24 24"
  //             >
  //               <path
  //                 strokeLinecap="round"
  //                 strokeLinejoin="round"
  //                 d="M14 10h4.764a2 2 0 0 1 1.95 2.434l-.89 4A2 2 0 0 1 17.88 18H8l-4 4V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2"
  //               />
  //             </svg>
  //           </span>
  //         </div>
  //         <h1 className="text-3xl font-bold text-gray-900 mb-2">
  //           Mental Health
  //         </h1>
  //         <p className="text-lg text-gray-700 mb-4">
  //           This feature is coming soon.
  //         </p>
  //         <p className="text-gray-500 mb-6">
  //           Our team is working to bring you AI-powered, confidential mental
  //           health resources, self-assessments, and professional support. Stay
  //           tuned!
  //         </p>
  //         <button
  //           onClick={() => setCurrentPage("home")}
  //           className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium"
  //         >
  //           Back to Home
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );

  // UPDATED: Render current page with all new pages
  const renderCurrentPage = () => {
    // Video call flow takes priority
    if (isInWaitingRoom)
      return <WaitingRoomPage onJoin={handleJoinVideoCall} />;
    if (isOnVideoCall) return <VideoCallPage onEndCall={handleEndCall} />;
    if (callEnded) return <CallEndedPage onClose={handleCallEndedClose} />;

    // Regular pages
    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "chat":
        return <ChatPage />;
      case "appointments":
        return <AppointmentsPage />;
      case "records":
        return <RecordsPage />;
      case "profile":
        return <ProfilePage />;
      case "settings":
        return <ProfilePage />;
      case "bookappointment":
        return <BookAppointmentPage />;
      case "callnow":
        return <CallNowPage />;
      case "summary":
        return <AppointmentSummaryPage />;
      case "mentalHealth":
        return <MentalHealthPage />;
      default:
        return <HomePage />;
    }
  };

  return <div className="min-h-screen bg-gray-50">{renderCurrentPage()}</div>;
}

export default DashboardWhite;
